module.exports = __webpack_public_path__ + "static/img/Scott-Lycett.fff6de4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Scott-Lycett.jpg
// module id = aUAv
// module chunks = 0